import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "../../../utils/colors";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: colors.range_bg,
  borderRadius: "1rem",
  padding: "0.1875rem",
  height: "1.25rem",
  border: `0.0625rem solid ${colors.toggle_border}`,
  "& .MuiToggleButtonGroup-grouped": {
    margin: "0",
    border: 0,
    borderRadius: "1.25rem !important",
    padding: "0.125rem 0.75rem",
    fontWeight: 400,
    fontSize: "0.625rem",
    lineHeight: "100%",
    letterSpacing: "0%",
    textTransform: "none",
    transition: "all 0.2s ease",
    "&.Mui-selected": {
      backgroundColor: colors.toggle_selected_bg,
      color: colors.white,
      padding: "0.5rem",
    },
    "&:not(.Mui-selected)": {
      backgroundColor: "transparent",
      color: colors.chart_gray,
      padding: "0.5rem",
      "&:hover": {
        backgroundColor: colors.toggle_border,
      },
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.5rem",
    },
  },
  [theme.breakpoints.down("md")]: {
    height: "1.125rem",
  },
}));

interface CostViewToggleProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
}

export default function CostViewToggle({
  value,
  onChange,
}: CostViewToggleProps) {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newView: string | null
  ) => {
    if (newView !== null) {
      onChange(newView);
    }
  };

  return (
    <StyledToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="cost view"
    >
      <ToggleButton value="standard" aria-label="standard cost view">
        Standard Cost View
      </ToggleButton>
      <ToggleButton value="actual" aria-label="actual cost view">
        Actual Cost View
      </ToggleButton>
    </StyledToggleButtonGroup>
  );
}
